import { CommissionStatuses } from 'constants/commissionStatuses';
import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { Commission, CommissionActiveStep } from 'types/embedded/commission';
import { ErrorData } from 'types/embedded/error';
import { formatAxiosToHydraError } from 'utils/formatAxiosToHydraError';

export const getCommissionsAvailableActions = async (id: number): Promise<CommissionStatuses[]> => {
  return axios
    .get(`${Resources.Commissions}/${id}/available-status-list`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export type UpdateCommissionsStatusParams = {
  status: CommissionStatuses;
  comment?: string;
};

export const updateCommissionsStatus = async (
  id: string,
  data: UpdateCommissionsStatusParams,
): Promise<CommissionStatuses[]> => {
  return axios
    .patch(`${Resources.Commissions}/${id}/status`, data)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const getCommissionsActiveSteps = async (id: string): Promise<CommissionActiveStep[]> => {
  return axios
    .get(`${Resources.Commissions}/${id}/methods_turnover`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

type CommissionRatePayload = {
  percent: string | null;
  fix: string | null;
  min: string | null;
  max: string | null;
  zeroed: boolean;
};

type CommissionStepPayload = {
  stepNumber: number;
  thresholdFrom: string | null;
  thresholdTo: string | null;
  commissionRate: Omit<CommissionRatePayload, 'zeroed'>;
};

type CommissionLadderPayload = {
  periodType: string | null;
  ladderType: string | null;
  steps: CommissionStepPayload[] | undefined;
};

type CommissionCommonPayload = {
  name: string;
  merchant: string;
  provider: string | null;
  currency: string;
  transactionTypes: string[];
  calculationMethod: string | null;
};

// Обычная комиссия - с rate, без ladder
export type CommissionRegularPayload = CommissionCommonPayload & {
  rate: CommissionRatePayload;
  ladder?: never;
};

// Комиссия с лесенкой - с ladder, без rate
export type CommissionLadderRootPayload = CommissionCommonPayload & {
  ladder: CommissionLadderPayload | null;
  rate?: never;
};

export type CommissionPayload = CommissionRegularPayload | CommissionLadderRootPayload;

export const createCommission = async (
  data: CommissionPayload,
  targetStatus?: string,
): Promise<Commission> => {
  return axios
    .post(Resources.Commissions, data, {
      params: targetStatus ? { targetStatus } : undefined,
      headers: { Accept: 'application/ld+json' },
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError<ErrorData>) => Promise.reject(formatAxiosToHydraError(error)));
};
